import type * as React from 'react';
import { get } from '@Domain/Api';
import beneficiaryIndicatorsFetched, {
	type BeneficiaryIndicatorsFetchedAction,
	type BeneficiaryIndicatorsPayload,
} from '@Application/Indicators/Actions/beneficiaryIndicatorsFetched';
import beneficiaryIndicatorsFetchFailed, {
	type BeneficiaryIndicatorsFetchFailedAction,
} from '@Application/Indicators/Actions/beneficiaryIndicatorsFetchFailed';
import resolveIndicatorBasePath from '@Application/Indicators/resolveIndicatorBasePath';
import type FetchBeneficiaryIndicators from '@Application/Indicators/Queries/FetchBeneficiaryIndicators';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = BeneficiaryIndicatorsFetchedAction | BeneficiaryIndicatorsFetchFailedAction;

type BeneficiaryIndicatorsResponse = Omit<BeneficiaryIndicatorsPayload, 'queryKey'>;

export default (query: FetchBeneficiaryIndicators) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const response = await get<BeneficiaryIndicatorsResponse>(
				`${resolveIndicatorBasePath(query.scope)}/beneficiaries?${query.toQueryString()}`,
			);

			const action = beneficiaryIndicatorsFetched({ ...response, queryKey: query.queryKey });
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiaryIndicatorsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
